import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_SETTINGS_ADD_LICENCE_URL } from "api/Service";

/**
 * Self-serve licence top-up: re-enters the admin's password, and on success adds the given
 * quantity of licenced users (one, if not supplied) to the tenant. A wrong password answers 401
 * with "Incorrect password." — left for the caller to show inline, rather than a toast, so the
 * modal stays open to retry.
 */
export const useAddLicence = (tenantVal) => {
  return useMutation({
    mutationFn: async ({ password, quantity }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}${PRACTICE_SETTINGS_ADD_LICENCE_URL}`,
        { password, quantity }
      );
      return response.data;
    },
  });
};
